export default {"src":"/_next/static/media/ZION.d7710749.svg","height":18,"width":18};